// Imports
import JoditEditor from "jodit-react";
import { FunctionComponent, useMemo, useRef } from "react";
import { joditConfig } from "v2/constants/constants";

// Main component properties types
type PropertyDescriptionSectionProps = {
  data: {
    highlights: string;
    overview: string;
    setHighlights: (value: string) => void;
    setOverview: (value: string) => void;
  };
};

// Main Component
export const PropertyDescriptionSection: FunctionComponent<
  PropertyDescriptionSectionProps
> = (props) => {
  // Set HTML tags references
  const highlightEditor = useRef(null);
  const overviewEditor = useRef(null);

  // Jodit configuration (Any type to avoid Jodit's bug)
  const config: any = useMemo(() => joditConfig, [props]);

  // Return memoized HTML component to avoid Jodit's bug on use "onChange" property
  return useMemo(
    () => (
      <div className="flex flex-col gap-6 p-6">
        <div>
          <label className="text-sm text-slate-600">Agent Highlights</label>

          <div>
            <JoditEditor
              ref={highlightEditor}
              value={props.data.highlights}
              key="highlight-editor"
              onChange={(value) => props.data.setHighlights(value)}
              config={{
                ...config,
                placeholder:
                  "Add any highlights related to the property. Max of 4000 characters.",
              }}
            />
          </div>
        </div>

        <div>
          <label className="text-sm text-slate-600">Property Overview</label>

          <div>
            <JoditEditor
              ref={overviewEditor}
              value={props.data.overview}
              key="overview-editor"
              onChange={(value) => props.data.setOverview(value)}
              config={{
                ...config,
                placeholder:
                  "Add the property's project overiew. Max of 4000 characters.",
              }}
            />
          </div>
        </div>
      </div>
    ),
    []
  );
};
